<template>
  <div class="content">
    <HeaderProductResale
        title="Saques - Histórico"
        text="Registro de todos os saques"
        actionTitle=""
        :haveAction="false"
        :haveBack="true"
    >
    </HeaderProductResale>

    <v-container style="max-width: unset">
      <v-card elevation="0" class="pa-3">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Data de início</label>
            <v-text-field
                v-model="filter.startDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Data de término</label>
            <v-text-field
                v-model="filter.endDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Status</label>
            <v-select
                hide-details
                outlined
                :items="statusList"
                class="secondary-input"
                placeholder="status"
                append-icon="mdi-chevron-down"
                item-text="text"
                item-value="value"
                v-model="filter.status"
                dense
                height="41"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col justify="end" cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
                 class="px-2 d-flex justify-end"
                 style="margin-top: -20px; "
          >
            <v-btn
                outlined
                height="41"
                style="border-radius: 8px!important;"
                class="mr-3"
                large
                @click="exportWithdrawals"
            >
              Exportar
            </v-btn>

            <v-btn
                outlined
                height="41"
                style="border-radius: 8px!important;"
                class="mr-3"
                large
                @click="withdrawals()"
            >
              Buscar
            </v-btn>

            <v-btn
                outlined
                style="border-radius: 8px!important;"
                large
                height="41"
                dense
                @click="reset"
            >
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          class="content-table"
          hide-default-footer
          loading-text="Buscando..."
          no-data-text="Sem registros"
      >
        <template v-slot:[`item.status`]="{ item }">
          <span v-if="item.status == 'created'">Criado</span>
          <span v-else-if="item.status == 'pending'">Pendente</span>
          <span v-else-if="item.status == 'processing'">Processando</span>
          <span v-else-if="item.status == 'transferred'">Transferido</span>
          <span v-else-if="item.status == 'failed'">Falhou</span>
          <span v-else-if="item.status == 'canceled'">Cancelado</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.payment_method`]="{ item }">
          <span v-if="item.payment_method == 'pix'">Pix</span>
          <span v-else-if="item.payment_method == 'credit_card'">Cartão de Crédito</span>
          <span v-else-if="item.payment_method == 'boleto'">Boleto</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.amount`]="{ item }">
          {{
            (Number(item.amount) / 100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>

        <template v-slot:[`item.fee`]="{ item }">
          {{
            (Number(item.fee) / 100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>

        <template v-slot:footer class="ma-0 pa-0">
          <section class="ma-0 pa-0">
            <Pagination
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </template>
      </v-data-table>

      <v-card elevation="0" class="pa-3" >
        <v-row>
          <v-col>
            <h3><strong>Legenda</strong></h3>
            <div>
              <strong>Taxa de processamento por boleto:</strong> <span>{{
                (3.49).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }} </span>
            </div>
            <div>
              <strong>Taxa de processamento por pix: </strong> <span>1.19% </span>
            </div>
            <div>
              <strong>Taxa de processamento por cartão de crédito: </strong> <span>{{
                (0.99).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }} </span>
            </div>
            <div>
              <strong>Parcelamento em 1x: </strong> <span> 3.48% </span><br/>
              <strong>Parcelamento em 2x a 5x:  </strong> <span>3.66% </span><br/>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<style scoped>
.content {
  background: #e5e5e5;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import HeaderProductResale from "./components/HeaderProductResale.vue";
import {VMoney} from "v-money";

import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";
import Utils from "../../../Utils/FormatDate";

export default {
  name: "Withdrawal",

  async created() {
    const {resaleId} = this.$route.query
    this.resaleId = resaleId ? resaleId : null;
    const jsonFilters = localStorage.getItem("financial-payments");
    if (jsonFilters) {
      this.filter = JSON.parse(localStorage.getItem("financial-payments"));
      this.page = this.filter.page;
    }
    await this.withdrawals();
  },

  data: () => ({
    pageCount: 1,
    pageSize: 10,
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    page: 1,
    items: [],
    statusList: [
      {
        value: 'created',
        text: 'Criado',
      },
      {
        value: 'pending',
        text: 'Pendente',
      },
      {
        value: 'processing',
        text: 'Processando',
      },
      {
        value: 'transferred',
        text: 'Transferido',
      },
      {
        value: 'failed',
        text: 'Falhou',
      },
      {
        value: 'canceled',
        text: 'Cancelado',
      },
    ],
    loading: false,
    headers: [
      {
        text: "Status",
        class: "item",
        sortable: false,
        align: "center",
        value: "status",
      },
      {
        text: "Criado em",
        class: "item",
        sortable: false,
        align: "center",
        value: "created_at",
      },
      {
        text: "Valor",
        class: "item",
        sortable: false,
        align: "center",
        value: "amount",
      },
      {
        text: "Taxas",
        class: "item",
        sortable: false,
        align: "center",
        value: "fee",
      },
    ],
    apiService: new ApiService(),
    filter: {
      page: 1,
      size: 10,
      startDate: null,
      endDate: null,
      status: null,
    },
  }),

  components: {
    Pagination,
    HeaderProductResale,
  },

  directives: {money: VMoney},

  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    reset() {
      this.filter = {
        page: 1,
        size: 10,
        startDate: null,
        endDate: null,
        status: null,
      }
      this.withdrawals()
    },
    async withdrawals() {
      try {
        this.filter.resaleId = JSON.parse(localStorage.getItem("user")).id;
        await this.apiService
            .post(`resale/withdrawals`, this.filter)
            .then((withdrawals) => {
              const {content} = withdrawals;
              const {data, paging} = content
              const {total} = paging
              this.items = data;
              this.currentPage = this.filter.page;
            });
      } catch (e) {

      }
    },

    async exportWithdrawals() {
      try {
        const body = {
          page: 1,
          size: 10,
          startDate: null,
          endDate: null,
          status: null,
          resaleId: JSON.parse(localStorage.getItem("user")).id
        }
        await this.apiService
            .post(`resale/withdrawals/export`, body)
            .then((response) => {
              const excel = `data:application/octet-stream;base64,${response.content}`;
              const link = document.createElement("a");
              link.href = excel;
              link.setAttribute("download", `saques.xlsx`);
              document.body.appendChild(link);
              link.click();
            });
      } catch (e) {

      }
    },
    async backPage() {
      this.filter.page -= 1;
      await this.withdrawals()
    },

    async nextPage() {
      this.filter.page += 1;
      await this.withdrawals()
    },
  },

  watch: {},
};
</script>
